import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const ThunderBadge = ({ size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 91 91">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="1-copy-48" transform="translate(-142.000000, -332.000000)">
          <G id="Group-4" transform="translate(144.000000, 334.000000)">
            <Circle
              id="Oval"
              stroke="#FFE66D"
              strokeWidth="4"
              fill="#F35F5F"
              cx="43.5"
              cy="43.5"
              r="43.5"
            />
            <G
              id="lightning"
              transform="translate(43.884373, 43.978782) rotate(11.000000) translate(-43.884373, -43.978782) translate(25.384373, 13.978782)"
              fillRule="nonzero"
            >
              <Path
                d="M13.9849701,58.8568472 L36.3399774,19.6720755 C36.8460803,18.7848857 36.1282994,17.6931549 35.1296774,17.8314362 L20.2596945,19.8889467 L23.8126021,0.900389176 C23.9323643,0.260261996 23.1216489,-0.106529149 22.735195,0.412832363 L0.755321871,29.9485655 C0.115080837,30.8087904 0.793016402,32.0320037 1.84733129,31.919074 L18.2413957,30.1623253 L12.8669254,58.4302493 C12.7373151,59.1120914 13.6423234,59.4574489 13.9849701,58.8568472 Z"
                id="Path"
                fill="#FFDC64"
              />
              <Path
                d="M7.82860958,28.028092 C7.40188574,28.0615237 7.11846205,27.6044318 7.34529512,27.2487878 L24.4258964,0.470468274 C24.171768,0.273451889 23.7717512,0.260770904 23.5295057,0.574106502 L0.684544199,30.1219531 C0.0191044267,30.9826461 0.723722318,32.2062458 1.81953314,32.0932697 L18.8588385,30.3358006 L13.2728387,58.6153182 C13.1975414,58.9967852 13.4601407,59.265161 13.7670948,59.3293729 L23.3391447,29.650451 C23.7878695,28.259347 22.6558219,26.8657068 21.1716418,26.9821413 L7.82860958,28.028092 Z"
                id="Path"
                fill="#FFC850"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};

ThunderBadge.defaultProps = {
  size: 91,
};

export default ThunderBadge;
